export const CREATE_BOOK = 'CREATE_BOOK';
export const GET_BOOK = 'GET_BOOK';
export const BOOK_REQUEST = 'BOOK_REQUEST';
export const DELETE_BOOK = 'DELETE_BOOK';
export const UPDATE_BOOK = 'UPDATE_BOOK';
export const BOOK_REQUEST_FAILURE = 'BOOK_REQUEST_FAILURE';
export const UPDATE_BOOK_IN_LIST = 'UPDATE_BOOK_IN_LIST';
export const ADD_BOOK_IN_LIST = 'ADD_BOOK_IN_LIST';
export const DELETE_BOOK_IN_LIST = 'DELETE_BOOK_IN_LIST';